type Props = React.ComponentProps<"svg"> & {
	size?: string | number;
};

export const StrikkefasthetIcon = ({ size = 18, ...rest }: Props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 18 18"
			fill="none"
			{...rest}
		>
			<path
				d="M1 16.5L4 13.5L7 16.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 16.5L14 13.5L17 16.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 12.5L4 9.5L7 12.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 12.5L14 9.5L17 12.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 8.5L4 5.5L7 8.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 8.5L14 5.5L17 8.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 4.5L4 1.5L7 4.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 4.5L14 1.5L17 4.5"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
